import React from 'react';
import PropTypes from 'prop-types';
import { dateStringToHowLongAgo, round } from '../../utils';
import PreviewImg from '../preview_img/PreviewImg';
import Rating from '../../rating/rating';
import UserProfileImage from './UserProfileImage';
import ResponseItem from './ResponseItem';
import '../review_item/ReviewItem.scss';

/**
 * This component support the review in User(buyer or seller) and Gig page and should replace ReviewItem component when backward compatibility will not be needed anymore.
 */
const NewReviewItem = ({ review }) => {

    const workSample = review.get('work_sample'),
        username = review.get('username'),
        sellerResponse = review.get('seller_response'),
        createdAt = dateStringToHowLongAgo(review.get('created_at'));

    return (
        <li>
            {workSample && <PreviewImg smallImgUrl={review.get('work_sample_small')} bigImgUrl={workSample}/>}

            <UserProfileImage username={username} userImage={review.get('user_image_url')}/>

            <header>
                <h5>{username}</h5>
                <Rating ratingFive={round(review.get('value')/2, 1)}/>
            </header>

            <p>{review.get('comment')}</p>
            <time>{createdAt} {i18n.t('reviews.general.ago')}</time>

            {sellerResponse && <ResponseItem sellerResponse={sellerResponse}/>}
        </li>
    );
};

NewReviewItem.propTypes = {
    review: PropTypes.shape({
        username: PropTypes.string,
        work_sample_small: PropTypes.string,
        work_sample: PropTypes.string,
        user_image_url: PropTypes.string,
        value: PropTypes.number,
        comment: PropTypes.string,
        created_at: PropTypes.string,
        seller_response: PropTypes.shape({
            id: PropTypes.string,
            value: PropTypes.number,
            comment: PropTypes.string,
            created_at: PropTypes.string
        })
    }).isRequired
};

export default NewReviewItem;



// WEBPACK FOOTER //
// ./src/reviews/reviews_list/NewReviewItem/index.js